// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__O9iyB","inner":"Footer_inner__2k84v","nextIcon":"Footer_nextIcon__27oCL","innerLeft":"Footer_innerLeft__1sPO8"};